
export const EDIT_CHANGE_LOG_ADD_HISTORY_LABEL = "История изменений предыдущих версий"

export const EDIT_CHANGE_LOG_ADD_HISTORY_BUTTON = "Добавить историю изменений"

export const EDIT_CHANGE_LOG_ADD_PREV_VERSION_LABEL = "Номер предыдущей версии"

export const EDIT_CHANGE_LOG_ADD_PREV_VERSION_DESCRIPTION_LABEL = "Изменения предыдущей версии"
